import type React from "react";

import { Route, Routes } from "react-router-dom";

import { useProfileContext } from "contexts/ProfileContext";
import { Container } from "shared/atoms/Container";
import { usePageContentOffsetTop } from "shared/styles/usePageContentOffsetTop";
import { userIsPartner, userIsPhysician } from "utils/profile/profileHelper";

import { Dashboard } from "./default/views/Dashboard";
import { PartnerDashboard } from "./partnerui/PartnerDashboard";
import { PhysicianDashboard } from "./physician/views/PhysicianDashboard";

export const DashboardRoutes: React.FC = () => {
  const { profile } = useProfileContext();
  const offsetTop = usePageContentOffsetTop();
  const isPartner = userIsPartner(profile);
  const isPhysician = userIsPhysician(profile);

  if (isPartner) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <Container $pageContentOffsetTop={offsetTop}>
              <PartnerDashboard />
            </Container>
          }
        />
      </Routes>
    );
  }

  if (isPhysician) {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <Container $pageContentOffsetTop={offsetTop}>
              <PhysicianDashboard />
            </Container>
          }
        />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Container $pageContentOffsetTop={offsetTop}>
            <Dashboard />
          </Container>
        }
      />
    </Routes>
  );
};
